import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import EnrollActions, { EnrollRedux, EnrollTypes } from '../Redux/EnrollRedux'
import InscriptionsActions from '../Redux/InscriptionsRedux'
import ClassroomActions from '../Redux/ClassroomRedux'
import { notificationSuccess } from '../Redux/NotificationActions'

const enrollCrudObservable = createCRUDObservable({
  mainRedux: EnrollRedux,
  reduxPath: 'enroll',
})

const postEnrollEpic = (action$, store, { Api }) =>
  action$.ofType(EnrollTypes.enrollRequest)
    .mergeMap(({ studentId, data }) => (
      Observable
        .fromPromise(Api.enroll.postEnroll(studentId, data)
          .then(result => result)
          .catch(error => error))
        .flatMap((result) => {
          const { status } = result
          if (!(status >= 200 && status < 300)) {
            return [EnrollActions.enrollFailure(result.error)]
          }
          const { data: { data: payload } } = result
          return [
            EnrollActions.enrollSuccess(payload),
            notificationSuccess('Alumno Registrado'),
            InscriptionsActions.updateDataAfterInscription(payload),
            ClassroomActions.updateDataAfterInscription(payload),
          ]
        })
    ))

const deleteEnrollEpic = (action$, store, { Api }) =>
  action$.ofType(EnrollTypes.deleteEnrollRequest)
    .mergeMap(({ studentId, data }) => (
      Observable
        .fromPromise(Api.enroll.deleteEnroll(studentId, data)
          .then(result => result)
          .catch(error => error))
        .flatMap((result) => {
          const { status } = result
          if (!(status >= 200 && status < 300)) {
            return [EnrollActions.deleteEnrollFailure(result.error)]
          }
          return [
            EnrollActions.deleteEnrollSuccess(studentId),
            notificationSuccess('Alumno Eliminado'),
            InscriptionsActions.updateDataAfterDeleteInscription(studentId),
          ]
        })
    ))


export const enrollObservers = Object.assign({}, enrollCrudObservable.observers, {
  postEnrollEpic,
  deleteEnrollEpic
})

export const enrollEpic = combineEpics(
  postEnrollEpic,
  deleteEnrollEpic
)



// WEBPACK FOOTER //
// ./src/Data/Observables/EnrollObservable.js